import React from "react";
import styled from "styled-components";
import { COLORS } from "../../../assets/constants/styles";

export const Table = ({
  columns,
  data,
  emptyMessage,
  loadingMessage,
  isLoading,
  renderCustomCell,
  onRowClick,
}) => {
  if (isLoading && data.length === 0) {
    return <LoadingMessage>{loadingMessage}</LoadingMessage>;
  }

  const handleRowClick = (item) => {
    if (onRowClick) {
      onRowClick(item);
    }
  };

  return (
    <Container>
      {data.length === 0 ? (
        <EmptyState>{emptyMessage}</EmptyState>
      ) : (
        <TableWrapper>
          <StyledTable>
            <thead>
              <tr>
                {columns.map((column) => (
                  <th key={column.key} style={column.style}>
                    {column.header}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.map((item) => {
                return (
                  <tr
                    key={item.id}
                    onClick={() => handleRowClick(item)}
                    $clickable={!!onRowClick}
                  >
                    {columns.map((column) => (
                      <StyledCell
                        key={`${item.id}-${column.key}`}
                        $width={column.width}
                        $align={column.align || "center"}
                        $wrap={column.wrap || false}
                        $maxWidth={column.maxWidth}
                      >
                        {renderCustomCell
                          ? renderCustomCell(item, column.key, column)
                          : item[column.key] || "-"}
                      </StyledCell>
                    ))}
                  </tr>
                );
              })}
            </tbody>
          </StyledTable>
        </TableWrapper>
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;

const LoadingMessage = styled.div`
  text-align: center;
  padding: 2rem;
  color: #666;
`;

const EmptyState = styled.div`
  text-align: center;
  padding: 3rem;
  background-color: #f9fafb;
  border-radius: 0.75rem;
  border: 1px dashed #cbd5e1;
  color: #64748b;
`;

const TableWrapper = styled.div`
  overflow-x: auto;
  border-radius: 0.75rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
`;

const StyledTable = styled.table`
  width: 100%;
  min-width: 900px;
  border-collapse: collapse;

  tr {
    background-color: ${COLORS.white};
    transition: all 0.2s;
  }

  th {
    padding: 0.5rem 1rem;
    text-align: center;
    border-bottom: 1px solid #e2e8f0;
    font-size: 0.8rem;
    font-weight: 600;
    color: #64748b;
    position: sticky;
    top: 0;
  }

  tbody tr:hover {
    background-color: ${COLORS.lightestViolet};
  }
`;

const StyledCell = styled.td`
  padding: 0.5rem 1rem;
  text-align: ${(props) => props.$align};
  border-bottom: 1px solid #e2e8f0;
  font-size: 0.875rem;
  width: ${(props) => props.$width || "auto"};
  max-width: ${(props) => props.$maxWidth || "none"};
  text-align: center;

  ${(props) =>
    props.$wrap
      ? `
      white-space: normal;
      word-break: break-word;
      overflow-wrap: break-word;
    `
      : `
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    `};
`;
